import React from 'react'
import Helmet from 'react-helmet'
import config from '../utils/siteConfig'
import '../templates/base.scss'
import Layout from '../components/Layout/Layout'
import SEO from '../components/SEO'
import AIContent from '../components/AI/AIContent/AIContent'
import AIHero from '../components/AI/AIHero/AIHero'

const AI = ({ data }) => {
  const postNode = {
    title: `AI & Machine Learning - ${config.siteTitle}`,
  }

  return (
    <Layout>
      <SEO postNode={postNode} pagePath="ai" customTitle />
      <Helmet>
        <title>{`AI & Machine Learning - ${config.siteTitle}`}</title>
      </Helmet>
      <AIHero />
      <AIContent />
    </Layout>
  )
}

export default AI
